// Provider
import { CreateProviderModalDialog } from '@Features/provider/createProvider/CreateProviderModalDialog';
import { CreateProviderCancelModalDialog } from '@Features/provider/createProvider/CreateProviderCancelModalDialog';
import { SetupProviderDrawer } from '@Features/providers/drawer/SetupProviderDrawer';
import { SetupProviderDrawerCancelDialog } from '@Features/providers/drawer/SetupProviderDrawerCancelDialog';
import { DeleteProviderModalDialog } from '@Features/provider/deleteProvider/DeleteProviderModalDialog';
import { CreateProviderConfigModalDialog } from '@Features/provider/createProviderConfig/CreateProviderConfigModalDialog';
import { CreateProviderConfigCancelModalDialog } from '@Features/provider/createProviderConfig/CreateProviderConfigCancelModalDialog';
import { UpdateProviderConfigModalDialog } from '@Features/provider/updateProviderConfig/UpdateProviderConfigModalDialog';
import { UpdateProviderConfigCancelModalDialog } from '@Features/provider/updateProviderConfig/UpdateProviderConfigCancelModalDialog';
// Round
import { SetupRoundDrawer } from '@Features/rounds/SetupRound/SetupRoundDrawer';
import { CreateRoundConfigModalDialog } from '@Features/rounds/CreateRoundConfig/CreateRoundConfigModalDialog';
import { CreateRoundConfigCancelModalDialog } from '@Features/rounds/CreateRoundConfig/CreateRoundConfigCancelModalDialog';
import { SetupAvTransactionDrawer } from '@Features/transaction/SetupAvTransactionDrawer/SetupAvTransactionDrawer';
// Users
import { CreateUserModalDialog } from '@Features/users/CreateUser/CreateUserModalDialog';
import { CreateUserCancelModalDialog } from '@Features/users/CreateUser/CreateUserCancelModalDialog';
import { SetupAviatorRoleDrawer } from '@Features/users/SetupAviatorRoleDrawer/SetupAviatorRoleDrawer';
import { CreateAviatorRoleModalDialog } from '@Features/users/CreateAviatorRole/CreateAviatorRoleModalDialog';
import { CancelCreateAviatorRoleModalDialog } from '@Features/users/CreateAviatorRole/CancelCreateAviatorRoleModalDialog';
import { SetupAviatorRoleDeleteModalDialog } from '@Features/users/SetupAviatorRoleDrawer/SetupAviatorRoleDeleteModalDialog';
import { DeleteProviderConfigModalDialog } from '@Features/provider/deleteProviderConfig/DeleteProviderConfigModalDialog';
import { UpdateRoundStatusModalDialog } from '@Features/rounds/RoundStatus/UpdateRoundStatusModalDialog';
import { CreateAviatorPermissionModalDialog } from '@Features/users/CreateAviatorPermission/CreateAviatorPermissionModalDialog';
import { SelectedRolePermissionDeleteModalDialog } from '@Features/users/CreateAviatorPermission/SelectedRolePermissionDeleteModalDialog';
import { AddRolePermissionsModalDialog } from '@Features/users/CreateAviatorPermission/AddRolePermissionsModalDialog';
// Localizations
import { CreateLocalizationKeyModalDialog } from '@Features/localizations/CreateLocalizationKey/CreateLocalizationKeyModalDialog';
import { CreateLanguageModalDialog } from '@Features/localizations/CreateLanguage/CreateLanguageModalDialog';
import { SetupUserDrawer } from '@Features/users/UserDrawer/SetupUserDrawer';
import { CreateRaindropModalDialog } from '@Features/raindrop/Createraindrop/CreateRaindropModalDialog';
import { CreateRaindropCancelModalDialog } from '@Features/raindrop/Createraindrop/CreateRaindropCancelModalDialog';
import { CancelRaindropModalDialog } from '@Features/raindrop/CancelRaindrop/CancelRaindropModalDialog';
import { SetupUserDrawerCancelDialog } from '@Features/users/UserDrawer/SetupUserDrawerCancelDialog';
import { DeleteUserModalDialog } from '@Features/users/UserDrawer/DeleteUserModalDialog';
import { CreateCampaignModalDialog } from '@Features/campaigns/CreateCampaign/CreateCampaignModalDialog';
import { CreateCampaignCancelModalDialog } from '@Features/campaigns/CreateCampaign/CreateCampaignCancelModalDialog';
import { CreateFreebetsModalDialog } from '@Features/freebets/CreateFreebets/CreateFreebetsModalDialog';
import { CreateFreebetsCancelModalDialog } from '@Features/freebets/CreateFreebets/CreateFreebetsCancelModalDialog';
import { SetupCampaignDrawer } from '@Features/campaigns/drawer/SetupCampaignDrawer';
import { SetupCampaignDrawerCancelDialog } from '@Features/campaigns/drawer/SetupCampaignDrawerCancelDialog';
import { RevokeFreebetModalDialog } from '@Features/campaigns/CreateCampaign/RevokeFreebetModalDialog';
import { RevokeFreebetsModalDialog } from '@Features/freebets/RevokeFreebets/RevokeFreebetsModalDialog';

export const dialogs = (
  <>
    <CreateProviderModalDialog />
    <CreateProviderConfigModalDialog />
    <CreateProviderConfigCancelModalDialog />
    <UpdateProviderConfigModalDialog />
    <UpdateProviderConfigCancelModalDialog />
    <DeleteProviderConfigModalDialog />
    <CreateProviderCancelModalDialog />
    <SetupProviderDrawer />
    <SetupProviderDrawerCancelDialog />
    <DeleteProviderModalDialog />
    <SetupRoundDrawer />
    <CreateRoundConfigModalDialog />
    <CreateRoundConfigCancelModalDialog />
    <SetupAvTransactionDrawer />
    <CreateUserModalDialog />
    <SetupUserDrawer />
    <CreateUserCancelModalDialog />
    <SetupAviatorRoleDrawer />
    <CreateAviatorRoleModalDialog />
    <CancelCreateAviatorRoleModalDialog />
    <SetupAviatorRoleDeleteModalDialog />
    <UpdateRoundStatusModalDialog />
    <CreateAviatorPermissionModalDialog />
    <SelectedRolePermissionDeleteModalDialog />
    <AddRolePermissionsModalDialog />
    <CreateLocalizationKeyModalDialog />
    <CreateLanguageModalDialog />
    <CreateRaindropModalDialog />
    <CreateRaindropCancelModalDialog />
    <CancelRaindropModalDialog />
    <SetupUserDrawerCancelDialog />
    <DeleteUserModalDialog />
    <CreateCampaignModalDialog />
    <CreateCampaignCancelModalDialog />
    <CreateFreebetsModalDialog />
    <CreateFreebetsCancelModalDialog />
    <SetupCampaignDrawer />
    <SetupCampaignDrawerCancelDialog />
    <RevokeFreebetModalDialog />
    <RevokeFreebetsModalDialog />
  </>
);
